import DeadlineRoutes from './routes'

const Deadlines = () => (
  <DeadlineRoutes />
)

export default Deadlines
